import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import SandboxClasses from '@/pages/sandbox/SandboxClasses';
import SandboxInstances from '@/pages/sandbox/SandboxInstances';
import SandboxTraces from '@/pages/sandbox/SandboxTraces';
import { BoxIcon, ServerIcon, TraceIcon } from '@/pages/sandbox/shared';

export default function SandboxesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<'class' | 'instance' | 'trace'>(() => {
    const tab = searchParams.get('tab');
    return tab === 'instance' ? 'instance' : tab === 'trace' ? 'trace' : 'class';
  });

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab === 'instance' || tab === 'class' || tab === 'trace') {
      setActiveTab(tab);
    }
  }, [searchParams]);

  const handleTabChange = (id: string) => {
    setActiveTab(id as 'class' | 'instance' | 'trace');
    setSearchParams({ tab: id });
  };

  const tabMeta = {
    class: { label: '沙箱模版', icon: <BoxIcon /> },
    instance: { label: '实例', icon: <ServerIcon /> },
    trace: { label: '沙箱运行记录', icon: <TraceIcon /> },
  };

  return (
    <div className="min-h-screen bg-muted/20">
      <div className="space-y-6">
        <div className="space-y-6">
          <div>
            <h1 className="text-2xl font-bold text-foreground tracking-tight">沙箱管理</h1>
            <p className="text-sm text-muted-foreground mt-1">管理和创建沙箱模版、实例及追踪记录</p>
          </div>

          <div className="flex items-center gap-1 p-1 bg-muted rounded-lg w-fit">
            {(['class', 'instance', 'trace'] as const).map((tab) => {
              const meta = tabMeta[tab];
              return (
                <button
                  key={tab}
                  onClick={() => handleTabChange(tab)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${
                    activeTab === tab
                      ? 'bg-background shadow-sm text-foreground'
                      : 'text-muted-foreground hover:text-foreground'
                  }`}
                >
                  <span className={activeTab === tab ? 'text-primary' : ''}>{meta.icon}</span>
                  {meta.label}
                </button>
              );
            })}
          </div>

          {activeTab === 'class' && <SandboxClasses />}
          {activeTab === 'instance' && <SandboxInstances />}
          {activeTab === 'trace' && <SandboxTraces />}
        </div>
      </div>
    </div>
  );
}
